import { render } from "./Fq.component.html?vue&type=template&id=104cf180&ts=true&external"
import script from "./Fq.component.ts?vue&type=script&lang=ts&external"
export * from "./Fq.component.ts?vue&type=script&lang=ts&external"

import "./Fq.component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__